import "./index.css"
import { Suspense } from "react"
import ReactDOM from "react-dom"
import ErrorBoundary from "./modules/error"
import initI18n from "./services/i18n"

import AppProviders from "providers"
import Loading from "components/loader"
import Router from "modules/router"
import { BrowserRouter } from "react-router-dom"

/**
 * Function to start API mock service worker,
 * used to develop and review,
 * comment it out before merging.
 */
/* if (process.env.NODE_ENV === "development") {
  const { worker } = require("./__mocks__")
  worker.start()
} */

initI18n()

const Root = () => (
  <Suspense fallback={<Loading />}>
    <BrowserRouter>
      <ErrorBoundary>
        <AppProviders>
          <Router />
        </AppProviders>
      </ErrorBoundary>
    </BrowserRouter>
  </Suspense>
)

ReactDOM.render(<Root />, document.getElementById("root"))
